import loadable from '@loadable/component';

import { MODAL_DIALOG__ERROR } from 'react-redux-app/lib/modules/globalErrorDialog/constants/dialogs';

import {
  MODAL_DIALOG__BANNER_CODE,
  MODAL_DIALOG__EDIT_CUSTOM_THUMBNAIL_BANNER,
} from '../affiliateTools/constants/dialogs';
import {
  MODAL_DIALOG__CHANGE_PASSWORD,
  MODAL_DIALOG__DELETE_ACCOUNT,
} from '../auth/constants/dialogs';
import {
  MODAL_DIALOG__CREATE_BANNER,
  MODAL_DIALOG__EDIT_BANNER,
} from '../banner/constants/dialogs';
import {
  MODAL_DIALOG__CREATE_CAMPAIGN,
  MODAL_DIALOG__EDIT_CAMPAIGN,
} from '../campaign/constants/dialogs';
import {
  MODAL_DIALOG__VISITORS_CHART,
  MODAL_DIALOG__REVENUE_CHART,
} from '../campaignStats/constants/dialogs';
import { MODAL_DIALOG__CONTACT_US } from '../contactUs/constants/dialogs';
import {
  MODAL_DIALOG__PAYOUT_CANCEL_REASON,
  MODAL_DIALOG__PAYOUT_REQUEST_DETAILS,
} from '../payout/constants/dialogs';
import { MODAL_DIALOG__CREATE_SITE_ALIAS } from '../siteAlias/constants/dialogs';
import {
  MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_CATEGORY,
  MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_CATEGORY,
  MODAL_DIALOG__CREATE_SITE_FOOTER_LINK,
  MODAL_DIALOG__EDIT_SITE_FOOTER_LINK,
  MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_TRANSLATION,
  MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_TRANSLATION,
} from '../siteFooterLinks/constants/dialogs';
import {
  MODAL_DIALOG__EDIT_SEO_TRANSLATIONS,
  MODAL_DIALOG__CREATE_CUSTOM_TAG,
} from '../siteSeo/constants/dialogs';
import {
  MODAL_DIALOG__ADD_PAGE_CONTENT,
  MODAL_DIALOG__EDIT_PAGE_CONTENT,
  MODAL_DIALOG__EDIT_PAGE,
  MODAL_DIALOG__ADD_PAGE,
  MODAL_DIALOG__EDIT_PAGE_CONTENT_SEO_DIALOG,
} from '../siteStaticPages/constants/dialogs';
import { MODAL_DIALOG__EDIT_SITE_TEXT } from '../siteTexts/constants/dialogs';
import { MODAL_DIALOG__SOCIAL_SETTINGS } from '../socialNetworksSettings/constants/dialogs';
import { MODAL_DIALOG__WIRE_FILE } from '../wire/constants/dialogs';
import { MODAL_DIALOG__ORDER_XCARD } from '../xcard/constants/dialogs';

import { CONFIRMATION_DIALOG__DELETE_BANNER } from '../banner/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__CANCEL_PAYOUT_REQUEST } from '../payout/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__DELETE_SITE } from '../site/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__DELETE_SITE_ALIAS } from '../siteAlias/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__CANCEL_SITE_ARTICLE } from '../siteArticle/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__DELETE_FAVICON } from '../siteFavicon/constants/confirmationDialogs';
import {
  CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_CATEGORY,
  CONFIRMATION_DIALOG__DELETE_FOOTER_LINK,
  CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_TRANSLATION,
} from '../siteFooterLinks/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__DELETE_GOOGLE_TOOL } from '../siteGoogleTool/constants/confirmationDialogs';
import {
  CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS,
  CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS_BY_LANG,
  CONFIRMATION_DIALOG__DELETE_CUSTOM_TAG,
} from '../siteSeo/constants/confirmationDialogs';
import {
  CONFIRMATION_DIALOG__DELETE_PAGE,
  CONFIRMATION_DIALOG__DELETE_PAGE_CONTENT,
} from '../siteStaticPages/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__RESET_FILE } from '../siteTemplateConfiguration/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__DELETE_SITE_TEXT } from '../siteTexts/constants/confirmationDialogs';
import { CONFIRMATION_DIALOG__CANCEL_WIRE } from '../wire/constants/confirmationDialogs';


const GlobalErrorDialog = loadable(() => import('../core/globalErrorDialog/components/GlobalErrorDialog'));

const BannerCodeDialog = loadable(() => import('../affiliateTools/containers/dialogs/BannerCodeDialog'));
const EditCustomThumbnailBannerDialog = loadable(() => import('../affiliateTools/containers/dialogs/EditCustomThumbnailBannerDialog'));
const ChangePasswordDialog = loadable(() => import('../auth/containers/dialogs/ChangePasswordDialog'));
const DeleteAccountDialog = loadable(() => import('../auth/containers/dialogs/DeleteAccountDialog'));
const CreateBannerDialog = loadable(() => import('../banner/containers/dialogs/CreateBannerDialog'));
const EditBannerDialog = loadable(() => import('../banner/containers/dialogs/EditBannerDialog'));
const CreateCampaignDialog = loadable(() => import('../campaign/containers/dialogs/CreateCampaignDialog'));
const EditCampaignDialog = loadable(() => import('../campaign/containers/dialogs/EditCampaignDialog'));
const VisitorsChartDialog = loadable(() => import('../campaignStats/containers/dialogs/VisitorsChartDialog'));
const RevenueChartDialog = loadable(() => import('../campaignStats/containers/dialogs/RevenueChartDialog'));
const ContactUsDialog = loadable(() => import('../contactUs/containers/dialogs/ContactUsDialog'));
const PayoutCancelReason = loadable(() => import('../payout/containers/dialogs/PayoutCancelReason'));
const PayoutRequestDetails = loadable(() => import('../payout/containers/dialogs/PayoutRequestDetails'));
const CreateSiteAliasDialog = loadable(() => import('../siteAlias/containers/dialogs/CreateSiteAliasDialog'));
const CreateSiteFooterLinkCategoryDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/CreateSiteFooterLinkCategoryDialog'));
const EditSiteFooterLinkCategoryDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/EditSiteFooterLinkCategoryDialog'));
const CreateSiteFooterLinkDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/CreateSiteFooterLinkDialog'));
const EditSiteFooterLinkDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/EditSiteFooterLinkDialog'));
const CreateSiteFooterLinkTranslationDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/CreateSiteFooterLinkTranslationDialog'));
const EditSiteFooterLinkTranslationDialog = loadable(() => import('../siteFooterLinks/containers/dialogs/EditSiteFooterLinkTranslationDialog'));
const EditSeoTranslationsDialog = loadable(() => import('../siteSeo/containers/dialogs/EditSeoTranslationsDialog'));
const CreateCustomTagDialog = loadable(() => import('../siteSeo/containers/dialogs/CreateCustomTagDialog'));
const AddPageContentDialog = loadable(() => import('../siteStaticPages/containers/dialogs/AddPageContentDialog'));
const EditPageContentDialog = loadable(() => import('../siteStaticPages/containers/dialogs/EditPageContentDialog'));
const EditPageDialog = loadable(() => import('../siteStaticPages/containers/dialogs/EditPageDialog'));
const AddPageDialog = loadable(() => import('../siteStaticPages/containers/dialogs/AddPageDialog'));
const EditPageContentSeoDialog = loadable(() => import('../siteStaticPages/containers/dialogs/EditPageContentSeoDialog'));
const EditSiteTextDialog = loadable(() => import('../siteTexts/containers/dialogs/EditSiteTextDialog'));
const SocialSettingsDialog = loadable(() => import('../socialNetworksSettings/containers/dialogs/SocialSettingsDialog'));
const WireFileDialog = loadable(() => import('../wire/containers/dialogs/WireFileDialog'));
const OrderXCardDialog = loadable(() => import('../xcard/containers/dialogs/OrderXCardDialog'));

const DeleteBanner = loadable(() => import('../banner/containers/confirmationDialogs/DeleteBanner'));
const CancelPayoutRequest = loadable(() => import('../payout/containers/confirmationDialogs/CancelPayoutRequest'));
const DeleteSite = loadable(() => import('../site/containers/confirmationDialogs/DeleteSite'));
const DeleteSiteAlias = loadable(() => import('../siteAlias/containers/confirmationDialogs/DeleteSiteAlias'));
const CancelSiteArticle = loadable(() => import('../siteArticle/containers/confirmationDialogs/CancelSiteArticle'));
const DeleteFavicon = loadable(() => import('../siteFavicon/containers/confirmationDialogs/DeleteFavicon'));
const DeleteCategory = loadable(() => import('../siteFooterLinks/containers/confirmationDialogs/DeleteCategory'));
const DeleteLink = loadable(() => import('../siteFooterLinks/containers/confirmationDialogs/DeleteLink'));
const DeleteLinkTranslation = loadable(() => import('../siteFooterLinks/containers/confirmationDialogs/DeleteLinkTranslation'));
const DeleteSiteGoogleTool = loadable(() => import('../siteGoogleTool/containers/confirmationDialogs/DeleteSiteGoogleTool'));
const DeleteSeoTranslations = loadable(() => import('../siteSeo/containers/confirmationDialogs/DeleteSeoTranslations'));
const DeleteSeoTranslationsByLang = loadable(() => import('../siteSeo/containers/confirmationDialogs/DeleteSeoTranslationsByLang'));
const DeleteCustomTag = loadable(() => import('../siteSeo/containers/confirmationDialogs/DeleteCustomTag'));
const DeletePage = loadable(() => import('../siteStaticPages/containers/confirmationDialogs/DeletePage'));
const DeletePageContent = loadable(() => import('../siteStaticPages/containers/confirmationDialogs/DeletePageContent'));
const ResetFile = loadable(() => import('../siteTemplateConfiguration/containers/confirmationDialogs/ResetFile'));
const DeleteSiteText = loadable(() => import('../siteTexts/containers/confirmationDialogs/DeleteSiteText'));
const CancelWire = loadable(() => import('../wire/containers/confirmationDialogs/CancelWire'));

export default {
  [MODAL_DIALOG__ERROR]: GlobalErrorDialog,
  [MODAL_DIALOG__VISITORS_CHART]: VisitorsChartDialog,
  [MODAL_DIALOG__REVENUE_CHART]: RevenueChartDialog,
  [MODAL_DIALOG__CHANGE_PASSWORD]: ChangePasswordDialog,
  [MODAL_DIALOG__DELETE_ACCOUNT]: DeleteAccountDialog,
  [MODAL_DIALOG__PAYOUT_CANCEL_REASON]: PayoutCancelReason,
  [MODAL_DIALOG__PAYOUT_REQUEST_DETAILS]: PayoutRequestDetails,
  [MODAL_DIALOG__CREATE_CAMPAIGN]: CreateCampaignDialog,
  [MODAL_DIALOG__EDIT_CAMPAIGN]: EditCampaignDialog,
  [MODAL_DIALOG__BANNER_CODE]: BannerCodeDialog,
  [MODAL_DIALOG__EDIT_CUSTOM_THUMBNAIL_BANNER]: EditCustomThumbnailBannerDialog,
  [MODAL_DIALOG__CREATE_BANNER]: CreateBannerDialog,
  [MODAL_DIALOG__EDIT_BANNER]: EditBannerDialog,
  [MODAL_DIALOG__EDIT_SEO_TRANSLATIONS]: EditSeoTranslationsDialog,
  [MODAL_DIALOG__CREATE_SITE_ALIAS]: CreateSiteAliasDialog,
  [MODAL_DIALOG__ADD_PAGE_CONTENT]: AddPageContentDialog,
  [MODAL_DIALOG__EDIT_PAGE_CONTENT]: EditPageContentDialog,
  [MODAL_DIALOG__EDIT_PAGE]: EditPageDialog,
  [MODAL_DIALOG__ADD_PAGE]: AddPageDialog,
  [MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_CATEGORY]: CreateSiteFooterLinkCategoryDialog,
  [MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_CATEGORY]: EditSiteFooterLinkCategoryDialog,
  [MODAL_DIALOG__CREATE_SITE_FOOTER_LINK]: CreateSiteFooterLinkDialog,
  [MODAL_DIALOG__EDIT_SITE_FOOTER_LINK]: EditSiteFooterLinkDialog,
  [MODAL_DIALOG__CREATE_SITE_FOOTER_LINK_TRANSLATION]: CreateSiteFooterLinkTranslationDialog,
  [MODAL_DIALOG__EDIT_SITE_FOOTER_LINK_TRANSLATION]: EditSiteFooterLinkTranslationDialog,
  [MODAL_DIALOG__EDIT_PAGE_CONTENT_SEO_DIALOG]: EditPageContentSeoDialog,
  [MODAL_DIALOG__CREATE_CUSTOM_TAG]: CreateCustomTagDialog,
  [MODAL_DIALOG__EDIT_SITE_TEXT]: EditSiteTextDialog,
  [MODAL_DIALOG__SOCIAL_SETTINGS]: SocialSettingsDialog,
  [MODAL_DIALOG__CONTACT_US]: ContactUsDialog,
  [MODAL_DIALOG__WIRE_FILE]: WireFileDialog,
  [MODAL_DIALOG__ORDER_XCARD]: OrderXCardDialog,

  [CONFIRMATION_DIALOG__CANCEL_PAYOUT_REQUEST]: CancelPayoutRequest,
  [CONFIRMATION_DIALOG__DELETE_SITE]: DeleteSite,
  [CONFIRMATION_DIALOG__DELETE_SITE_ALIAS]: DeleteSiteAlias,
  [CONFIRMATION_DIALOG__DELETE_BANNER]: DeleteBanner,
  [CONFIRMATION_DIALOG__RESET_FILE]: ResetFile,
  [CONFIRMATION_DIALOG__CANCEL_SITE_ARTICLE]: CancelSiteArticle,
  [CONFIRMATION_DIALOG__DELETE_FAVICON]: DeleteFavicon,
  [CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS]: DeleteSeoTranslations,
  [CONFIRMATION_DIALOG__DELETE_GOOGLE_TOOL]: DeleteSiteGoogleTool,
  [CONFIRMATION_DIALOG__DELETE_PAGE]: DeletePage,
  [CONFIRMATION_DIALOG__DELETE_PAGE_CONTENT]: DeletePageContent,
  [CONFIRMATION_DIALOG__DELETE_SITE_TEXT]: DeleteSiteText,
  [CONFIRMATION_DIALOG__DELETE_SEO_TRANSLATIONS_BY_LANG]: DeleteSeoTranslationsByLang,
  [CONFIRMATION_DIALOG__DELETE_CUSTOM_TAG]: DeleteCustomTag,
  [CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_CATEGORY]: DeleteCategory,
  [CONFIRMATION_DIALOG__DELETE_FOOTER_LINK]: DeleteLink,
  [CONFIRMATION_DIALOG__DELETE_FOOTER_LINK_TRANSLATION]: DeleteLinkTranslation,
  [CONFIRMATION_DIALOG__CANCEL_WIRE]: CancelWire,
};
